"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var styled_components_1 = __importStar(require("styled-components"));

var Image = function Image(_a) {
  var src = _a.src,
      alt = _a.alt,
      width = _a.width,
      customRoot = _a.customRoot;
  var intrinsicWidth = width ? width.replace(/px/, "") : undefined;
  return React.createElement(exports.ImageStyled, {
    src: src,
    alt: alt ? alt : undefined,
    width: intrinsicWidth
  });
};

exports["default"] = Image;
exports.ImageStyled = styled_components_1["default"].img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 100%;\n  height: auto;\n\n  ", ";\n"], ["\n  max-width: 100%;\n  height: auto;\n\n  ", ";\n"])), function (_a) {
  var width = _a.width;
  return width && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: ", "px;\n    "], ["\n      width: ", "px;\n    "])), width);
});
var templateObject_1, templateObject_2;